// Subscription action types
export const FETCH_SUBSCRIPTION_DATA_REQUEST = 'FETCH_SUBSCRIPTION_DATA_REQUEST';
export const FETCH_SUBSCRIPTION_DATA_SUCCESS = 'FETCH_SUBSCRIPTION_DATA_SUCCESS';
export const FETCH_SUBSCRIPTION_DATA_FAILURE = 'FETCH_SUBSCRIPTION_DATA_FAILURE';

export const FETCH_SUBSCRIPTION_PLANS_REQUEST = 'FETCH_SUBSCRIPTION_PLANS_REQUEST';
export const FETCH_SUBSCRIPTION_PLANS_SUCCESS = 'FETCH_SUBSCRIPTION_PLANS_SUCCESS';
export const FETCH_SUBSCRIPTION_PLANS_FAILURE = 'FETCH_SUBSCRIPTION_PLANS_FAILURE';

export const SELECT_SUBSCRIPTION_PLAN = 'SELECT_SUBSCRIPTION_PLAN';


export const CREATE_ORDER_REQUEST = 'CREATE_ORDER_REQUEST';
export const CREATE_ORDER_SUCCESS = 'CREATE_ORDER_SUCCESS';
export const CREATE_ORDER_FAILURE = 'CREATE_ORDER_FAILURE';
export const CLEAR_ORDER_DATA = 'CLEAR_ORDER_DATA';

export const VERIFY_PAYMENT_REQUEST = 'VERIFY_PAYMENT_REQUEST';
export const VERIFY_PAYMENT_SUCCESS = 'VERIFY_PAYMENT_SUCCESS';
export const VERIFY_PAYMENT_FAILURE = 'VERIFY_PAYMENT_FAILURE';

export const OPEN_RAZORPAY_CHECKOUT = 'OPEN_RAZORPAY_CHECKOUT';
export const RAZORPAY_CHECKOUT_SUCCESS = 'RAZORPAY_CHECKOUT_SUCCESS';
export const RAZORPAY_CHECKOUT_FAILURE = 'RAZORPAY_CHECKOUT_FAILURE';

export const CLOSE_SUCCESS_MODAL = 'CLOSE_SUCCESS_MODAL';

export const CLEAR_SUBSCRIPTION_DATA = 'CLEAR_SUBSCRIPTION_DATA';

// Blocked Users List
export const FETCH_BLOCKED_USERS_LIST_REQUEST = 'FETCH_BLOCKED_USERS_LIST_REQUEST';
export const FETCH_BLOCKED_USERS_LIST_SUCCESS = 'FETCH_BLOCKED_USERS_LIST_SUCCESS';
export const FETCH_BLOCKED_USERS_LIST_FAILURE = 'FETCH_BLOCKED_USERS_LIST_FAILURE';

